import { defaultPlatformRandom1jhqtnj1rulyk as defaultPlatformRandom } from './PlatformRandom.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  shiftLeft3tsh2sstjchzn as shiftLeft,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  modulooi4g1kq3dmtt as modulo,
  convertToInty04h231mmjoh as convertToInt,
  negate13xrbakfwasjy as negate,
  shiftRight2gqph14wydb8s as shiftRight,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { toByte4i43936u611k as toByte } from '../js/numberConversion.mjs';
import { XorWowRandom4dcuf9lla8j1 as XorWowRandom } from './XorWowRandom.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Random() {
      static go() {
        Default_instance = null;
        var $this = this.ho();
        Default_instance = $this;
        $this.fo_1 = defaultPlatformRandom();
        return $this;
      }
      io(bitCount) {
        return this.fo_1.io(bitCount);
      }
      nk() {
        return this.fo_1.nk();
      }
      b2(until) {
        return this.fo_1.b2(until);
      }
      jo(from, until) {
        return this.fo_1.jo(from, until);
      }
      ko() {
        return this.fo_1.ko();
      }
      lo(until) {
        return this.fo_1.lo(until);
      }
      mo(from, until) {
        return this.fo_1.mo(from, until);
      }
      no() {
        return this.fo_1.no();
      }
      oo(array) {
        return this.fo_1.oo(array);
      }
      po(size) {
        return this.fo_1.po(size);
      }
      qo(array, fromIndex, toIndex) {
        return this.fo_1.qo(array, fromIndex, toIndex);
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    Default().go();
  return Default_instance;
}
var RandomClass;
function Random() {
  if (RandomClass === VOID) {
    class $ {
      static ho() {
        Default_getInstance();
        return createThis(this);
      }
      nk() {
        return this.io(32);
      }
      b2(until) {
        return this.jo(0, until);
      }
      jo(from, until) {
        checkRangeBounds(from, until);
        var n = until - from | 0;
        if (n > 0 || n === -2147483648) {
          var tmp;
          if ((n & (-n | 0)) === n) {
            var bitCount = fastLog2(n);
            tmp = this.io(bitCount);
          } else {
            var v;
            do {
              var bits = this.nk() >>> 1 | 0;
              v = bits % n | 0;
            }
             while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
            tmp = v;
          }
          var rnd = tmp;
          return from + rnd | 0;
        } else {
          while (true) {
            var rnd_0 = this.nk();
            if (from <= rnd_0 ? rnd_0 < until : false)
              return rnd_0;
          }
        }
      }
      ko() {
        var tmp0 = shiftLeft(fromInt(this.nk()), 32);
        // Inline function 'kotlin.Long.plus' call
        var other = this.nk();
        return add(tmp0, fromInt(other));
      }
      lo(until) {
        return this.mo(0n, until);
      }
      mo(from, until) {
        checkRangeBounds_0(from, until);
        var n = subtract(until, from);
        if (n > 0n) {
          var rnd;
          if ((n & negate(n)) === n) {
            var nLow = convertToInt(n);
            var nHigh = convertToInt(shiftRightUnsigned(n, 32));
            var tmp;
            if (!(nLow === 0)) {
              var bitCount = fastLog2(nLow);
              tmp = fromInt(this.io(bitCount)) & 4294967295n;
            } else if (nHigh === 1) {
              tmp = fromInt(this.nk()) & 4294967295n;
            } else {
              var bitCount_0 = fastLog2(nHigh);
              tmp = add(shiftLeft(fromInt(this.io(bitCount_0)), 32), fromInt(this.nk()) & 4294967295n);
            }
            rnd = tmp;
          } else {
            var v;
            $l$1: do {
              $l$0: do {
                var bits = shiftRightUnsigned(this.ko(), 1);
                v = modulo(bits, n);
              }
               while (false);
              var tmp_0 = subtract(bits, v);
              // Inline function 'kotlin.Long.minus' call
              var tmp$ret$0 = subtract(n, fromInt(1));
            }
             while (add(tmp_0, tmp$ret$0) < 0n);
            rnd = v;
          }
          return add(from, rnd);
        } else {
          while (true) {
            var rnd_0 = this.ko();
            if (from <= rnd_0 ? rnd_0 < until : false)
              return rnd_0;
          }
        }
      }
      no() {
        return !(this.io(1) === 0);
      }
      qo(array, fromIndex, toIndex) {
        // Inline function 'kotlin.require' call
        if (!((0 <= fromIndex ? fromIndex <= array.length : false) && (0 <= toIndex ? toIndex <= array.length : false))) {
          var message = 'fromIndex (' + fromIndex + ') or toIndex (' + toIndex + ') are out of range: 0..' + array.length + '.';
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(fromIndex <= toIndex)) {
          var message_0 = 'fromIndex (' + fromIndex + ') must be not greater than toIndex (' + toIndex + ').';
          throw IllegalArgumentException().n2(toString(message_0));
        }
        var steps = (toIndex - fromIndex | 0) / 4 | 0;
        var position = fromIndex;
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < steps)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var v = this.nk();
            array[position] = toByte(v);
            array[position + 1 | 0] = toByte(v >>> 8 | 0);
            array[position + 2 | 0] = toByte(v >>> 16 | 0);
            array[position + 3 | 0] = toByte(v >>> 24 | 0);
            position = position + 4 | 0;
          }
           while (inductionVariable < steps);
        var remainder = toIndex - position | 0;
        var vr = this.io(imul(remainder, 8));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < remainder)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            array[position + i | 0] = toByte(vr >>> imul(i, 8) | 0);
          }
           while (inductionVariable_0 < remainder);
        return array;
      }
      oo(array) {
        return this.qo(array, 0, array.length);
      }
      po(size) {
        return this.oo(new Int8Array(size));
      }
    }
    initMetadataForClass($, 'Random');
    RandomClass = $;
  }
  return RandomClass;
}
function Random_0(seed) {
  return XorWowRandom().xo(seed, seed >> 31);
}
function Random_1(seed) {
  return XorWowRandom().xo(convertToInt(seed), convertToInt(shiftRight(seed, 32)));
}
function checkRangeBounds(from, until) {
  // Inline function 'kotlin.require' call
  if (!(until > from)) {
    var message = boundsErrorMessage(from, until);
    throw IllegalArgumentException().n2(toString(message));
  }
  return Unit_instance;
}
function fastLog2(value) {
  // Inline function 'kotlin.countLeadingZeroBits' call
  return 31 - clz32(value) | 0;
}
function checkRangeBounds_0(from, until) {
  // Inline function 'kotlin.require' call
  if (!(until > from)) {
    var message = boundsErrorMessage(from, until);
    throw IllegalArgumentException().n2(toString(message));
  }
  return Unit_instance;
}
function boundsErrorMessage(from, until) {
  return 'Random range is empty: [' + toString(from) + ', ' + toString(until) + ').';
}
function nextInt(_this__u8e3s4, range) {
  var tmp;
  if (range.n1()) {
    throw IllegalArgumentException().n2('Cannot get random in empty range: ' + range.toString());
  } else if (range.r3_1 < 2147483647) {
    tmp = _this__u8e3s4.jo(range.q3_1, range.r3_1 + 1 | 0);
  } else if (range.q3_1 > -2147483648) {
    tmp = _this__u8e3s4.jo(range.q3_1 - 1 | 0, range.r3_1) + 1 | 0;
  } else {
    tmp = _this__u8e3s4.nk();
  }
  return tmp;
}
function takeUpperBits(_this__u8e3s4, bitCount) {
  return (_this__u8e3s4 >>> (32 - bitCount | 0) | 0) & (-bitCount | 0) >> 31;
}
//region block: exports
export {
  Default_getInstance as Default_getInstance2tudkf86ziur0,
  Random_1 as Randomei1bbeye8rr8,
  Random_0 as Random2w0u2xak2xaqi,
  Random as Random24dxadk52mliy,
  nextInt as nextInt2pxj3bzg1eemu,
  takeUpperBits as takeUpperBits23varjnd7v1uz,
};
//endregion

//# sourceMappingURL=Random.mjs.map
